import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArchiveJunk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArchiveJunk"><Path d="M20.5 7.5V20.5H3.5V7.5" stroke="currentColor"/><Path d="M2.5 3.5H21.5V7.5H2.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 11.5L14.5 16.5M14.5 11.5L9.5 16.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconArchiveJunk;
